export default function StaffDashboard() {
    return <h2>Welcome, Staff Member</h2>;
  }
  